<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
    <div>
        <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
        <div class="position-relative w-100 overflow-hidden">
            <!-- Placeholder Hero Image -->
            <img src="	https://d3uop73ba1wtqg.cloudfront.net/uploads/I9vGemfVaajZv0IMSMRudIIlk8s5aipRUmXG26S2.jpg"
                alt="Hero Image" class="img-fluid w-100 d-block" style="filter: brightness(0.7);" />
            <div
                class="position-absolute top-0 h-100 d-flex flex-column justify-content-center hero-text-container text-start px-3 px-md-5">
                <h1 class="headingBL title mb-3 text-white">
                    NCERT-Aligned <br /> K-12 Content
                </h1>
            </div>
        </div>
    </div>
</div>

<!-- Subjects Grid Section -->
<section class="subjects-section py-5">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Covered <span>Subjects</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="subjects-grid">
            <div class="subject-item" *ngFor="let subject of subjects">
                <div class="icon-box">
                    <mat-icon>{{ subject.icon }}</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h4 class="subject-title">{{ subject.title }}</h4>
            </div>
        </div>
    </div>
</section>

<!-- Demo Videos Section -->
<!-- <section class="gallery-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Demo <span>Videos</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="gallery-grid">
            <div class="gallery-item" *ngFor="let video of demoVideos" (click)="openVideo(video)">
                <div class="video-wrapper">
                    <img [src]="'https://img.youtube.com/vi/' + video.videoId + '/maxresdefault.jpg'"
                        [alt]="video.title" loading="lazy"
                        onerror="this.src='https://img.youtube.com/vi/' + video.videoId + '/hqdefault.jpg'">
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Learning Outcomes Section -->
<section class="icon-features-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Learning <span>Outcomes</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="icon-features-grid">
            <div class="feature-item" *ngFor="let outcome of learningOutcomes">
                <div class="icon-box">
                    <mat-icon>{{ outcome.icon }}</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h4 class="feature-title">{{ outcome.title }}</h4>
                <p class="feature-desc">{{ outcome.description }}</p>
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="cta-section text-center">
    <div class="container mb-5 cta-buttons">
        <a routerLink="/form/contactUs" class="btn-cta btn-cta-secondary me-3">
            <mat-icon>play_circle_outline</mat-icon>
            View Demo
        </a>
        <a routerLink="/form/contactUs" class="btn-cta btn-cta-primary">
            <mat-icon>request_quote</mat-icon>
            Inquire
        </a>
    </div>
</section>